import keyboard from "@main/helpers/keyboard";

$(document).ready(function() {
    if(window.location.hash == "#buy"){
        $(".js-modal[data-modal=becomePartner]").addClass("fade-in opened")
            .removeClass("fade-out");
        $("body").addClass("modal-opened");
    }

    const btnOpen = (".js-open-modal"),
        $btnClose = $(".js-close-modal");

    $(document).on("click", btnOpen,  function(){

        let $modal = $(this).siblings(".js-modal"),
            dataModal = $(this).data("modal");

        if(dataModal){
            $modal= $(".js-modal[data-modal="+dataModal+"]");
            if(dataModal == "brochures"){
                let fileName = $(this).data("filename");
                $("input[name=DOWNLOADED_FILE]").val(fileName);
            }
        }

        $modal.addClass("fade-in opened")
            .removeClass("fade-out");

        $("body").addClass("modal-opened");
    });

    $btnClose.each(function(){
        $(this).on("click", () => {

            $(this).closest(".js-modal")
                .addClass("fade-out")
                .removeClass("fade-in");

            setTimeout(() => {
                $(this).closest(".js-modal").removeClass("opened");
                $("body").removeClass("modal-opened");
            },500);
        });
    });

    $(document).keyup(function(e){

        if(e.keyCode == keyboard.ESCAPE){

            $btnClose.trigger("click");
        }
    });
});
